import { render, staticRenderFns } from "./PorAssuntoFiscal.vue?vue&type=template&id=31ca4e31&scoped=true&lang=pug&"
import script from "./PorAssuntoFiscal.vue?vue&type=script&lang=js&"
export * from "./PorAssuntoFiscal.vue?vue&type=script&lang=js&"
import style0 from "./PorAssuntoFiscal.vue?vue&type=style&index=0&id=31ca4e31&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ca4e31",
  null
  
)

export default component.exports